import saveAs from 'file-saver';

export const csvImportPatientLeads = (params, successCallback) => {
  fetch(`/api/v1/patient_leads/import`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
  })
    .then((response) => response.json())
    .then((data) => {
      successCallback(data);
    });
};

export const createPatientLead = (params, successCallback) => {
  fetch('/api/v1/patient_leads', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
  })
    .then((response) => response.json())
    .then((data) => {
      successCallback(data);
    });
};

export const getPatientImportTemplate = () => {
  return fetch(`/api/v1/patient_leads/template`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/csv',
    },
  })
    .then((response) => {
      const filename = response.headers.get('X-Filename') || 'export.csv';
      return response.blob().then((blob) => ({ blob, filename }));
    })
    .then(({ blob, filename }) => {
      saveAs(blob, filename);
      return new Promise((resolve) => {
        // Give a small delay to ensure the file save dialog has appeared
        setTimeout(resolve, 100);
      });
    });
};
